import React from 'react'
import { create } from 'zustand'
import { WemoloModal } from '../../components/Wemolo'
import { GlobalSearchContainer } from './GlobalSearchContainer'
import styles from './GlobalSearchPage.module.css'

interface GlobalSearchPageStore {
    isOpen: boolean
    setIsOpen: (isOpen: boolean) => void
}

export const useGlobalSearchPageStore = create<GlobalSearchPageStore>((set) => ({
    isOpen: false,
    setIsOpen: (isOpen: boolean) => set({ isOpen })
}))

export const GlobalSearchPage = () => {
    const { isOpen, setIsOpen } = useGlobalSearchPageStore()
    const handleClose = () => setIsOpen(false)

    return (
        <WemoloModal isOpen={isOpen} onClose={handleClose} size="medium" bodyPadding="none" className={styles.modal}>
            <div className={styles.body}>
                <GlobalSearchContainer />
            </div>
        </WemoloModal>
    )
}
